import { CaDialogComponent } from '../ca-dialog.base'
import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'ca-input-text-dialog',
    templateUrl: './input-text-dialog.html',
    standalone: false
})
export class InputTextDialogComponent extends CaDialogComponent<{
    label: string;
    maxLength: number;
    message: string;
    okButtonTitle: string;
    title: string;
    value: string;
}, string> implements OnInit {

    label: string
    maxLength: number
    message: string
    okButtonTitle: string
    title: string
    value: string

    text: string

    constructor() {
        super()
    }

    ngOnInit() {
        this.text = this.value
    }

    closeModal(result?: string): void {
        super.result = result

        super.close()
    }
}